export const socketTypes = [
	{
		name: 'Liner',
		slug: 'liner',
	},
	{
		name: 'Soft inner socket made by Glaze',
		slug: 'made_by_glaze',
	},
	{
		name: 'Soft inner socket fabricated by myself',
		slug: 'fabricated_by_myself',
	},
];

export const socketTypesFinishing = [
	{
		name: 'Basic',
		slug: 'basic',
		description: 'Printed in FDM technology',
	},
	{
		name: 'Premium',
		slug: 'premium',
		description: 'Printed in MJF technology',
	},
];

export const outerSocketTypes = [
	{
		name: '3D printed socket made by Glaze',
		slug: 'made_by_glaze',
	},
	{
		name: 'Laminated socket fabricated by myself',
		slug: 'fabricated_by_myself',
	},
];

export const outerSocketColors = [
	{
		label: 'RAW print',
		value: 'raw_print',
	},
	{
		label: 'Special Finishing - painting/hydrographic (water transfer) finish',
		value: 'special_finishing',
	},
];
